/** Bump compare cost cache when assumptions or Work-For context changes (I16). */
export const COMPARE_COST_INVALIDATE = "penn:compare-cost-invalidate";

export function dispatchCompareCostInvalidate(): void {
  window.dispatchEvent(new CustomEvent(COMPARE_COST_INVALIDATE));
}

/**
 * Fired ONLY when the user manually switches the "Working for" target via the
 * WorkForSelector. The Selector resets its filter workspace on this so the new
 * customer starts from a clean slate. Deliberately distinct from
 * COMPARE_COST_INVALIDATE: the task-open flow ALSO changes Work-For but must
 * keep the task's restored filters, so it fires only the invalidate event, not
 * this one. (Switching customer is an explicit user reset, so this does not
 * violate the §D.11 "don't auto-clear after quote/RFQ" rule.)
 */
export const WORK_FOR_CHANGED = "penn:work-for-changed";

export function dispatchWorkForChanged(): void {
  window.dispatchEvent(new CustomEvent(WORK_FOR_CHANGED));
}
